import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './DichVuYTe.css';
import './Home.css';
import logo from './logo.png';

// Icon components
const MedkitIcon: React.FC<{ size?: number; color?: string }> = ({ size = 36, color = '#F57C00' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" role="img" aria-label="Medkit">
    <g fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" fill={color} opacity=".15" />
      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
      <polyline points="14,2 14,8 20,8" />
      <line x1="16" y1="13" x2="8" y2="13" />
      <line x1="16" y1="17" x2="8" y2="17" />
      <polyline points="10,9 9,9 8,9" />
    </g>
  </svg>
);

const ChatboxIcon: React.FC<{ size?: number; color?: string }> = ({ size = 36, color = '#F57C00' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" role="img" aria-label="Chatbox">
    <g fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" fill={color} opacity=".15" />
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </g>
  </svg>
);

const MedicalIcon: React.FC<{ size?: number; color?: string }> = ({ size = 36, color = '#F57C00' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" role="img" aria-label="Medical">
    <g fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2" fill={color} opacity=".15" />
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
      <line x1="9" y1="9" x2="15" y2="9" />
      <line x1="9" y1="15" x2="15" y2="15" />
      <line x1="12" y1="9" x2="12" y2="15" />
    </g>
  </svg>
);

const DichVuYTe: React.FC = () => {
	const navigate = useNavigate();
	const [navOpen, setNavOpen] = React.useState(false);
	React.useEffect(() => {
		document.title = 'Dịch vụ y tế - Fconnect';
	}, []);

	return (
		<div className="home-page">
			{/* Header (reuse from Home) */}
			<header className="home-header">
				<div className="home-container header-inner">
					<div className="brand" onClick={() => { navigate('/'); setNavOpen(false); }}>
						<img src={logo} alt="Fconnect" />
					</div>
					<button
						className="nav-toggle"
						aria-label={navOpen ? 'Đóng menu' : 'Mở menu'}
						aria-expanded={navOpen}
						aria-controls="main-navigation"
						onClick={() => setNavOpen((o) => !o)}
					>
						{navOpen ? '✕' : '☰'}
					</button>
					<nav id="main-navigation" className={`main-nav ${navOpen ? 'open' : ''}`}>
						<Link to="/" onClick={() => setNavOpen(false)}>Trang chủ</Link>
						<Link to="/lao-dong-pho-thong" onClick={() => setNavOpen(false)}>Lao động phổ thông</Link>
						<Link to="/lao-dong-nong-nghiep" onClick={() => setNavOpen(false)}>Lao động nông nghiệp</Link>
						<Link to="/dich-vu-y-te" onClick={() => setNavOpen(false)}>Dịch vụ y tế</Link>
						<Link to="/privacy" onClick={() => setNavOpen(false)}>Chính sách bảo mật</Link>
						<Link to="/terms" onClick={() => setNavOpen(false)}>Điều khoản</Link>
						<Link to="/contact" onClick={() => setNavOpen(false)}>Liên hệ</Link>
						<Link to="/en" className="lang-link" onClick={() => setNavOpen(false)}>English</Link>
					</nav>
				</div>
			</header>
			<div className={`nav-backdrop ${navOpen ? 'open' : ''}`} onClick={() => setNavOpen(false)} />

			{/* Banner Section */}
			<section className="ldt-banner-section">
				<div className="ldt-banner-content">
					<div className="ldt-banner-text">
						<h2>Dịch vụ y tế chất lượng cao tại nhà</h2>
						<p>Xét nghiệm, tư vấn và cung cấp thuốc theo toa với đội ngũ y tế chuyên nghiệp</p>
					</div>
					<div className="ldt-banner-visual">
						<div className="ldt-banner-icons">
							<MedkitIcon size={48} color="#F57C00" />
							<ChatboxIcon size={48} color="#F57C00" />
							<MedicalIcon size={48} color="#F57C00" />
						</div>
					</div>
				</div>
			</section>

			{/* Content */}
			<section className="home-container">
				<header className="ldt-hero">
					<h1>Dịch vụ y tế</h1>
					<p className="ldt-subtitle">Chăm sóc sức khỏe toàn diện với các dịch vụ y tế chất lượng cao, an toàn và tiện lợi.</p>
				</header>

				<div className="ldt-content">
					<section className="ldt-section">
						<h2 className="section-title">Các dịch vụ</h2>
						<div className="services-grid">
							<div className="service-card">
								<div className="service-icon"><MedkitIcon size={56} /></div>
								<h4>Xét nghiệm</h4>
								<p>Xét nghiệm máu, chức năng cơ thể và tầm soát bệnh lý với kết quả chính xác, nhanh chóng.</p>
							</div>
							<div className="service-card">
								<div className="service-icon"><ChatboxIcon size={56} /></div>
								<h4>Tư vấn bệnh</h4>
								<p>Tư vấn chuyên khoa với bác sĩ giàu kinh nghiệm, giải đáp thắc mắc về sức khỏe.</p>
							</div>
							<div className="service-card">
								<div className="service-icon"><MedicalIcon size={56} /></div>
								<h4>Bán thuốc theo toa</h4>
								<p>Cung cấp thuốc theo đơn bác sĩ, đảm bảo chất lượng và hướng dẫn sử dụng an toàn.</p>
							</div>
						</div>
					</section>

					<section className="ldt-section">
						<h2 className="section-title">Gói xét nghiệm</h2>
						<div className="packages-grid">
							<div className="package-card">
								<div className="package-header">
									<h3>Chức năng gan</h3>
									<p className="package-sub">Đánh giá sức khỏe gan</p>
								</div>
								<ul className="package-list">
									<li>AST, ALT, GGT</li>
									<li>Bilirubin toàn phần</li>
									<li>Protein toàn phần</li>
								</ul>
							</div>

							<div className="package-card">
								<div className="package-header">
									<h3>Chức năng thận - tiết niệu</h3>
									<p className="package-sub">Kiểm tra sức khỏe thận</p>
								</div>
								<ul className="package-list">
									<li>Ure, Creatinine</li>
									<li>Acid uric</li>
									<li>Điện giải đồ</li>
								</ul>
							</div>

							<div className="package-card">
								<div className="package-header">
									<h3>Kiểm tra đường huyết</h3>
									<p className="package-sub">Theo dõi bệnh tiểu đường</p>
								</div>
								<ul className="package-list">
									<li>Glucose lúc đói</li>
									<li>HbA1c</li>
									<li>Insulin</li>
								</ul>
							</div>

							<div className="package-card">
								<div className="package-header">
									<h3>Tim mạch - mỡ máu</h3>
									<p className="package-sub">Đánh giá nguy cơ tim mạch</p>
								</div>
								<ul className="package-list">
									<li>Cholesterol toàn phần</li>
									<li>HDL, LDL, Triglyceride</li>
									<li>CRP, Homocysteine</li>
								</ul>
							</div>

							<div className="package-card">
								<div className="package-header">
									<h3>Tầm soát ung thư</h3>
									<p className="package-sub">Phát hiện sớm bệnh lý</p>
								</div>
								<ul className="package-list">
									<li>CEA, AFP</li>
									<li>PSA (nam giới)</li>
									<li>CA 125 (nữ giới)</li>
								</ul>
							</div>

							<div className="package-card">
								<div className="package-header">
									<h3>Ký sinh trùng</h3>
									<p className="package-sub">Kiểm tra nhiễm ký sinh trùng</p>
								</div>
								<ul className="package-list">
									<li>Soi phân tươi</li>
									<li>Xét nghiệm máu</li>
									<li>Test nhanh</li>
								</ul>
							</div>

							<div className="package-card">
								<div className="package-header">
									<h3>Dị ứng</h3>
									<p className="package-sub">Xác định nguyên nhân dị ứng</p>
								</div>
								<ul className="package-list">
									<li>Test da</li>
									<li>Xét nghiệm máu</li>
									<li>Panel dị ứng</li>
								</ul>
							</div>

							<div className="package-card">
								<div className="package-header">
									<h3>ADN huyết thống</h3>
									<p className="package-sub">Xác định quan hệ huyết thống</p>
								</div>
								<ul className="package-list">
									<li>Cha - con</li>
									<li>Mẹ - con</li>
									<li>Anh chị em</li>
								</ul>
							</div>

							<div className="package-card">
								<div className="package-header">
									<h3>Xét nghiệm máu</h3>
									<p className="package-sub">Tổng quát sức khỏe</p>
								</div>
								<ul className="package-list">
									<li>Tổng phân tích tế bào máu</li>
									<li>Nhóm máu</li>
									<li>Đông máu cơ bản</li>
								</ul>
							</div>
						</div>
					</section>

					<section className="ldt-section">
						<h2 className="section-title">Gói tư vấn bệnh</h2>
						<div className="packages-grid">
							<div className="package-card">
								<div className="package-header">
									<h3>Tim mạch</h3>
									<p className="package-sub">Tư vấn chuyên khoa tim mạch</p>
								</div>
								<ul className="package-list">
									<li>Tăng huyết áp</li>
									<li>Bệnh mạch vành</li>
									<li>Rối loạn nhịp tim</li>
								</ul>
							</div>

							<div className="package-card">
								<div className="package-header">
									<h3>Tai mũi họng</h3>
									<p className="package-sub">Tư vấn chuyên khoa TMH</p>
								</div>
								<ul className="package-list">
									<li>Viêm mũi xoang</li>
									<li>Viêm họng</li>
									<li>Viêm tai giữa</li>
								</ul>
							</div>

							<div className="package-card">
								<div className="package-header">
									<h3>Răng hàm mặt</h3>
									<p className="package-sub">Tư vấn chuyên khoa RHM</p>
								</div>
								<ul className="package-list">
									<li>Sâu răng</li>
									<li>Viêm nướu</li>
									<li>Chỉnh nha</li>
								</ul>
							</div>

							<div className="package-card">
								<div className="package-header">
									<h3>Thần kinh</h3>
									<p className="package-sub">Tư vấn chuyên khoa thần kinh</p>
								</div>
								<ul className="package-list">
									<li>Đau đầu</li>
									<li>Rối loạn giấc ngủ</li>
									<li>Bệnh lý thần kinh</li>
								</ul>
							</div>
						</div>
					</section>
				</div>
			</section>

			{/* Footer (reuse from Home) */}
			<footer className="home-footer">
				<div className="home-container footer-inner">
					<div className="footer-contact">
						<p><strong>CÔNG TY CỔ PHẦN TÀI CHÍNH HIỆP TÍN PHÁT</strong></p>
						<p><strong>Email:</strong> trile@fconnect.vn</p>
						<p><strong>Điện thoại:</strong> 02513684266</p>
						<p><strong>Địa chỉ:</strong> 11/4C, tổ 15, Kp 6, đường Nguyễn Ái Quốc, Phường Trấn Biên, Tp. Đồng Nai, Việt Nam</p>
						<p><strong>Thời gian hỗ trợ:</strong> 8:00 - 22:00 (Thứ 2 - Chủ nhật)</p>
					</div>
					<div className="footer-stores">
						<a className="store-badge small appstore-badge" href="https://apps.apple.com/vn/app/fconnect-htp/id6752923786?l=vi" target="_blank" rel="noopener noreferrer">
							<span className="badge-icon" aria-hidden="true"></span>
							<span className="badge-text"><span className="badge-sub">Download on the</span><span className="badge-brand">App Store</span></span>
						</a>
						<a className="store-badge small play-badge" href="https://play.google.com/store/apps/details?id=com.taichinhhtp.fconnect&pcampaignid=web_share" target="_blank" rel="noopener noreferrer">
							<span className="badge-icon" aria-hidden="true">▶</span>
							<span className="badge-text"><span className="badge-sub">GET IT ON</span><span className="badge-brand">Google Play</span></span>
						</a>
					</div>
				</div>
				<div className="copyright">© 2025 Fconnect. Tất cả các quyền được bảo lưu.</div>
			</footer>
		</div>
	);
};

export default DichVuYTe;
